import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { generateRowIndex } from "../commons/Generate";
import { formatSplitKey } from "../commons/FormatValue";
import { filteredItemInRange } from "../utils/ManageArray";
import DataTable from "react-data-table-component";
import LoadingSpinner from "./LoadingSpinner";
import TableCustomPagination from "./TableCustomPagination";

const Table = ({
  data,
  column,
  pending,
  searchFilter,
  pagination = false,
  selectableRows = false,
  selectableRowsSingle = false,
  selectableRowSelected,
  clearSelectedRows = false,
  onSelectedRowsChange
}) => {
  const [filteredData, setFilteredData] = useState([]);

  const NoDataComponent = () => (
    <Card className="w-100 bg-transparent border-0">
      <Card.Header className="p-0 bg-transparent hQPXLq rdt_TableHead">
        <Row
          className="mx-0 flex-nowrap border-bottom-0 gocYik rdt_TableHeadRow"
          style={{
            width: column.length > 10 ? "max-content" : "100%",
            height: "53px"
          }}
        >
          {column?.map((col, idx) => (
            <Col
              key={idx}
              xs={column.length > 10 ? 2 : (!col.name || col.width) && 1}
              className={`${
                column.length > 10 && "w-auto"
              } px-3 d-flex align-items-center fs-4 fw-bold text-truncate`}
              style={{
                minWidth: col.minWidth,
                width: col.name ? col.width : "0px"
              }}
            >
              {col.name}
            </Col>
          ))}
        </Row>
      </Card.Header>

      <Card.Body className="p-0 kdgCYE rdt_TableBody">
        <Row className="w-100 mx-0 flex-nowrap gVZIpW rdt_TableRow">
          <Col className="w-100 py-3 fs-4 text-center text-secondary">
            ไม่พบข้อมูล
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const filteredDataInRange = (data, search) => {
    if (!search?.some(({ value }) => value)) return data;
    if (search?.some(({ type, value }) => value && type !== "date"))
      return data;
    else {
      const [start, end] = search.filter(
        ({ name, type }) =>
          type === "date" &&
          (name.toUpperCase().indexOf("START") !== -1 ||
            name.toUpperCase().indexOf("END") !== -1)
      );
      return filteredItemInRange(data, search, start?.name, end?.name);
    }
  };

  useEffect(() => {
    const filteredItems = filteredDataInRange(data, searchFilter)?.filter(
      (item) =>
        !searchFilter?.every(
          ({ name, duplicateKey }) =>
            name === formatSplitKey(name, ".", searchFilter?.[0]) ||
            duplicateKey
        )
          ? searchFilter?.every(({ name, value, type }) =>
              value && type !== "date"
                ? formatSplitKey(name, ".", item) === value
                : item
            )
          : searchFilter?.some(
              ({ name, value }) => formatSplitKey(name, ".", item) === value
            )
    );

    setFilteredData(filteredItems || []);
  }, [searchFilter, data]);

  return (
    <DataTable
      responsive
      highlightOnHover
      keyField="rowIndex"
      data={generateRowIndex(searchFilter ? filteredData : data)}
      columns={column}
      progressPending={pending}
      progressComponent={<LoadingSpinner />}
      noDataComponent={<NoDataComponent />}
      selectableRows={selectableRows}
      selectableRowsSingle={selectableRowsSingle}
      selectableRowSelected={selectableRowSelected}
      onSelectedRowsChange={onSelectedRowsChange}
      clearSelectedRows={clearSelectedRows}
      pagination={pagination}
      paginationRowsPerPageOptions={[10, 15, 20, 30]}
      paginationComponent={(props) => (
        <TableCustomPagination
          data={searchFilter ? filteredData : data}
          paginationProps={props}
        />
      )}
      paginationComponentOptions={{
        rowsPerPageText: "จำนวนต่อหน้า",
        rangeSeparatorText: "จาก",
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: "ทั้งหมด"
      }}
    />
  );
};

Table.propTypes = {
  data: PropTypes.array.isRequired,
  column: PropTypes.array.isRequired,
  pending: PropTypes.bool,
  searchFilter: PropTypes.array,
  pagination: PropTypes.bool,
  selectableRows: PropTypes.bool,
  selectableRowsSingle: PropTypes.bool,
  selectableRowSelected: PropTypes.func,
  onSelectedRowsChange: PropTypes.func,
  clearSelectedRows: PropTypes.bool
};

export default Table;
